module.exports = __webpack_public_path__ + "assets/img/thumb-superdraft-video.bc15ab59.jpg";